import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import scrollIntoView from 'scroll-into-view';
import { apiAction, get, pageContext } from 'ctm-util-functions';

import { CloseButton } from '../close_button/close_button';

/**
 * Call Us Now dropdown in results page
 */
class _CallUs extends Component {

    constructor(props) {
        super(props);

        /**
         * Local property to store the apiSchema, this component doesn't have component schema, so has to be put here
         * @type {Object} - apiSchema to CALL_DIRECT lead event call
         */
        this.apiSchema = {
            url: '/event',
            requestAction: 'CALL_DIRECT',
            type: 'POST',
            requestPayload: 'lead',
            failureType: 'non-fatal'
        };
    }

    /**
     * Dispatches apiAction to send CALL_DIRECT lead
     */
    componentDidUpdate = () => {
        const { dispatch, isVisible, stateProps } = this.props;
        if (isVisible) {
            scrollIntoView(this.node);
            const requestPayload = {
                productId: get(stateProps, 'product.productMeta.id', null)
            };

            dispatch(apiAction(
                this.apiSchema,
                pageContext.getProps().pageState,
                [],
                this.apiSchema.baseUrlName,
                requestPayload
            ));
        }
    };

    /**
     * Renders the children components through builderDirector
     * @returns {Node} constructed call us now html with layouts
     */
    render = () => {
        const { isVisible, layout, stateProps } = this.props;
        const quoteNumber = stateProps.product.getIn(['providerMeta', 'quoteNumber']);

        return (
            <div ref={(node) => { this.node = node; }}>
                { isVisible &&  <CloseButton stateProps={stateProps} id={'call'} /> }
                { isVisible && pageContext.getProps().director.constructComponents([layout], { resolvedStateProps: { quoteNumber }, stateProps })}
            </div>
        );
    };

}

_CallUs.propTypes = {
    isVisible: PropTypes.bool.isRequired,
    layout: PropTypes.string.isRequired,
    stateProps: PropTypes.object.isRequired,
    dispatch: PropTypes.func
};

const CallUs = connect()(_CallUs);
export { CallUs, _CallUs };
